"use strict";
/* globals module */
/**
 * @module commerceProductFilesBatchClient
 * @description  Files Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../httpApi");
var _1 = require(".././");
var CommerceProductFilesBatchClient = /** @class */ (function () {
    function CommerceProductFilesBatchClient(productFilesBatchRoute, apiClient) {
        this.productFilesBatchRoute = productFilesBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceProductFilesBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.productFilesBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove file resources from the system if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will remove just derived resource. Otherwise, specified file and all its accompanying derived resources will be removed from the system.
     * @method
     * @param data Collection of product files that needs to be deleted.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // Remove original file resources
                   productFilesBatchClient.unlink([{ id: '<file-id>' }])
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
               // Remove derived file resources
                   productFilesBatchClient.unlink([{ id: '<file-id>', fileFormat: { width: <width>, height: <height> } }])
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
    **/
    CommerceProductFilesBatchClient.prototype.unlink = function (data) {
        return this.apiClient.delete(this.productFilesBatchRoute.unlink(), undefined, data);
    };
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates specified file resources.
     * @method
     * @param data A collection of product files objects used to update specified product files.
     * @returns A promise that is resolved once the update action has been performed.
     * @example productFilesClient.batch.update(files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    CommerceProductFilesBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resources from other modules into the Files module (For example: file resources from the Media Vault module can be linked directly into the Files module).
     * @method
     * @param data A collection of product file objects that need to be inserted into the system.
     * @returns A promise that is resolved once the link action has been performed.
     * @example productFilesClient.batch.link(files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    CommerceProductFilesBatchClient.prototype.link = function (data) {
        return this.apiClient.post(this.routeDefinition.link(), this.routeDefinition.createParams(data));
    };
    var _a, _b;
    CommerceProductFilesBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CommerceProductFilesBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CommerceProductFilesBatchRoute !== "undefined" && _1.CommerceProductFilesBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceProductFilesBatchClient);
    return CommerceProductFilesBatchClient;
}());
exports.CommerceProductFilesBatchClient = CommerceProductFilesBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/
